// @flow

import dompurify from 'dompurify';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import winamaxLogoImage from '../../../assets/images/w-logo.svg';
import { Button, Icon } from '../../../modules/shared';
import { UNSET_LAYER_MODAL } from '../../../store/actions';
import type { RootState } from '../../../store/types';

const Wrapper = styled.div`
  position: fixed;
  z-index: 13;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  width: 100%;
  max-width: 630px;
  margin: 15px;
  background: #16191d;
  padding: 8px;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;
`;

const ButtonExit = styled.div`
  align-self: flex-end;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  width: 24px;
  height: 24px;
  padding: 5px;
  background: #454d54;
`;

const WinamaxLogo = styled.img`
  width: 60px;
  margin-top: -5px;
`;

const Title = styled.h2`
  margin-top: 15px;
  margin-bottom: 5px;
  font-size: 20px;
`;

const Text = styled.div`
  margin: 15px 10px 20px;

  a {
    color: #ffc514;
    font-weight: bold;
  }
`;

const RedirectButton = styled(Button)`
  width: fit-content;
  margin: 10px 0;
  height: 50px;
  text-align: center;
  text-transform: inherit;
`;

type LayerModalProps = {
  className?: string,
};

export const LayerModal = ({ className }: LayerModalProps) => {
  const { layerModal } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();
  const sanitizer = dompurify.sanitize;

  const onCloseModal = useCallback(() => {
    dispatch({ type: UNSET_LAYER_MODAL });
  }, [dispatch]);

  if (!layerModal) {
    return null;
  }

  return (
    <>
      <Wrapper>
        <Content>
          {!layerModal.hideCloseButton
            ? (
              <ButtonExit onClick={onCloseModal}>
                <Icon name={'close-square'} />
              </ButtonExit>
              )
            : null}
          <WinamaxLogo src={winamaxLogoImage} />
          <Title>{layerModal.title}</Title>
          <Text dangerouslySetInnerHTML={{ __html: sanitizer(layerModal.text) }} />
          <RedirectButton onClick={layerModal.button.action}>
            {layerModal.button.label}
          </RedirectButton>
        </Content>
      </Wrapper>
    </>
  );
};
